export default __webpack_public_path__ + "static/media/general.5c854d5f.png";